// alert.js
import React, { useCallback, useEffect, useState } from "react";
import { Platform } from "react-native";
import Alert, {isOpen} from "./AwesomeAlert";

// Placeholder for exportable member function.
var triggerAlert;  // Forces singleton component. Only one may exist for this window, shared across all 'imports'.

const AlertModal = () => {

  // UI Alert Feature
  class alertOpts {
    constructor({
      show = true,
      showProgress = false,
      title = null,
      body = null,
      message = null,
      customView = null,
      onDismiss = null,
      closeOnTouchOutside = true,
      closeOnHardwareBackPress = false,
      showCancelButton = false,
      showConfirmButton = true,
      cancelText = null,
      confirmText = null,
      cancelButtonStyle = null,
      confirmButtonStyle = null,
      cancelButtonColor = null,
      confirmButtonColor = null,
      onCancelPressed = triggerAlert,
      onConfirmPressed = triggerAlert,
      theme = null,
    } = {}) {
      this.show=show;
      this.showProgress=showProgress;
      this.title=title;
      this.message = (!!body&&typeof(body)==="string"?body:message);
      this.customView = (!!body&&typeof(body)==="object"?body:customView);
      this.onDismiss=onDismiss;
      this.closeOnTouchOutside=closeOnTouchOutside;
      this.closeOnHardwareBackPress=closeOnHardwareBackPress;
      this.showCancelButton=showCancelButton;
      this.showConfirmButton=showConfirmButton;
      this.cancelText=cancelText;
      this.confirmText=confirmText;
      this.cancelButtonStyle=cancelButtonStyle,
      this.confirmButtonStyle=confirmButtonStyle,
      this.cancelButtonColor=cancelButtonColor;
      this.confirmButtonColor=confirmButtonColor;
      this.onCancelPressed=onCancelPressed;
      this.onConfirmPressed=onConfirmPressed;
      this.theme = theme;
    }
  }

  const [alertState, setAlertState] = useState({
    show: false,
    showProgress: false,
    title: null,
    message: null,
    customView: null,
    onDismiss: null,
    closeOnTouchOutside: true,
    closeOnHardwareBackPress: false,
    showCancelButton: false,
    showConfirmButton: true,
    cancelText: null,
    confirmText: null,
    cancelButtonStyle: {},
    confirmButtonStyle: {},
    cancelButtonColor: null,
    confirmButtonColor: null,
    theme: null,
  });

  let _fromTop = (window.main.theme.respHeight < 800 ? (window.main.theme.respHeight/6) : (window.main.theme.respHeight < 600 ? (window.main.theme.respHeight/6) : 200));
  const AlertTag = useCallback(() => {
    return <Alert
      show={alertState.show}
      showProgress={alertState.showProgress}
      title={alertState.title || "Attention"}
      message={alertState.message}
      customView={alertState.customView}
      onDismiss={alertState.onDismiss}
      closeOnTouchOutside={alertState.closeOnTouchOutside}
      closeOnHardwareBackPress={alertState.closeOnHardwareBackPress}
      showCancelButton={alertState.showCancelButton}
      showConfirmButton={alertState.showConfirmButton}
      cancelText={alertState.cancelText || "Cancel"}
      confirmText={alertState.confirmText || "Ok"}
      cancelButtonColor={alertState.cancelButtonColor || (alertState.theme==="caution"?window.main.theme.colors.monoMedium:window.main.theme.colors.monoLight)}
      confirmButtonColor={alertState.confirmButtonColor || (alertState.theme==="caution"?window.main.theme.colors.caution:window.main.theme.colors.emphDark)}
      cancelButtonStyle={{width:68,textAlign:"center",...(alertState.cancelButtonStyle||{})}}
      confirmButtonStyle={{width:68,textAlign:"center",...(alertState.confirmButtonStyle||{})}}
      cancelButtonTextStyle={{color:(alertState.theme==="caution"?window.main.theme.colors.white:window.main.theme.colors.monoDark),...alertState.cancelButtonStyle||{}}}
      confirmButtonTextStyle={{color:(alertState.theme==="caution"?window.main.theme.colors.white:window.main.theme.colors.monoDark),...alertState.confirmButtonStyle||{}}}
      onCancelPressed={alertState.onCancelPressed || (() => {
        triggerAlert();
      })}
      onConfirmPressed={alertState.onConfirmPressed || (() => {
        triggerAlert();
      })}
      contentContainerStyle={{padding:10,minWidth:200,...(Platform.OS==="web" ? {position:"fixed", top:_fromTop, maxWidth:(!!alertState.customView?"none":312)} : {width:"auto"})}}
      overlayStyle={{ backgroundColor:window.main.theme.colors.monoMedium, opacity: 0.5, top:0, left:0, position:(Platform.OS==="web"?"fixed":"absolute"), ...(Platform.OS==="web" ? {height:"100%",width:"100%"}:{}) }}
       />
  },[alertState]);

  triggerAlert = useCallback((opts,onOpenCallback,onCloseCallback) => {
    if (!!window.tempRootSuggestInput?.current) {
      window.tempRootSuggestInput.close();
    }
    // If no options at all, close any open alert modal.
    if (!opts || typeof(opts) !== "object" || typeof(opts.show) === "undefined") {
      opts = {show: false};
    }
    // if options config but no 'show' attribute, assume intention to show the config content -> default missing 'show' = true.
    if (!("show" in opts)) {
      opts.show = true;
    }
    if (!!opts.show) {
      if (window.main.platform_os === "web") {
        window.addEventListener("keydown", onWindowKeyPress);
      }
    } else {
      if (window.main.platform_os === "web") {
        window.removeEventListener("keydown", onWindowKeyPress);
      }
    }
    setAlertState(new alertOpts(opts));
    if (typeof(onOpenCallback)==="function" && opts.show===true) {
      onOpenCallback();
    } else if (typeof(onCloseCallback)==="function" && opts.show===false) {
      onCloseCallback();
    }
  },[]);

  const onWindowKeyPress = useCallback((e)=>{
    if(e.key==="Enter") {  // Enter triggers confirm
      if (window.main.platform_os === "web" && alertState.showConfirmButton) {
        window.removeEventListener("keydown", onWindowKeyPress);
      }
      if (!!alertState && alertState.hasOwnProperty("onConfirmPressed")) {
        alertState.onConfirmPressed();
      }
    } else if (e.key==="Escape") {  // Escape or spacebar triggers cancel  --  Removed spacebar:  || e.key===" "
      if (window.main.platform_os === "web") {
        window.removeEventListener("keydown", onWindowKeyPress);
      }
      if (!!alertState && alertState.hasOwnProperty("onCancelPressed")) {
        alertState.onCancelPressed();
      } else if (!!isOpen()) {
        triggerAlert();
        return false;
      }
    }
  },[alertState]);

  useEffect(()=>{
    // if (window.main.platform_os === "web") {
    //   window.addEventListener("keydown", onWindowKeyPress);
    // }
    // On-Unmount Cleanup:
    return () => {
      if (window.main.platform_os === "web") {
        window.removeEventListener("keydown", onWindowKeyPress);
      }
      triggerAlert = {}._;  // Resets to 'undefined'.
    };
  },[]);

  // const alertModalProxyRootId = useRef(null);  // Used to track rootView.set ID on each instance of SuggestInput.
  // alertModalProxyRootId.current = rootView.set(<AlertTag />);
  // window.tempRootAlertModal.current = alertModalProxyRootId.current;
  return (
    <AlertTag />
  );

};

export default AlertModal;
export { triggerAlert };
